import { render, staticRenderFns } from "./amountConfirm.vue?vue&type=template&id=98375688&scoped=true"
import script from "./amountConfirm.vue?vue&type=script&lang=js"
export * from "./amountConfirm.vue?vue&type=script&lang=js"
import style0 from "./amountConfirm.vue?vue&type=style&index=0&id=98375688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98375688",
  null
  
)

export default component.exports